import _extends from "@babel/runtime/helpers/extends";

/*
 * @Author: wangshengqiang
 * @Date: 2021-05-19 11:31:01
 * @LastEditTime: 2021-10-27 17:19:57
 * @LastEditors: wangshengqiang
 * @Description: 性别组件
 */
import React, { useState, useEffect } from 'react';
import { Radio } from 'zarm';
import { CustomIcon } from '@/components/common';
import { getBirthday, getSex } from '@/utils/tool';
import { getPreLeveFormKey } from '@/utils/utils';
import { useStore, setFormValue } from '@/store';
import RowRadioList from '../RowRadioList';
import './index.less';

const isCard = idCard => {
  const arrExp = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]; // 加权因子

  const arrValid = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]; // 校验码

  if (/^\d{17}\d|x$/i.test(idCard)) {
    let sum = 0; // 对前17位数字与权值乘积求和

    for (let i = 0; i < idCard.length - 1; i++) {
      sum += parseInt(idCard.substr(i, 1), 10) * arrExp[i];
    } // 计算模（固定算法）


    const idx = sum % 11; // 检验第18为是否与校验码相等

    return arrValid[idx] == idCard.substr(17, 1).toUpperCase();
  }

  return false;
};

export const useDisable = formKey => {
  const [disabled, setDisabled] = useState(false);
  const formKeyPrefix = getPreLeveFormKey(formKey);
  const certType = useStore(`formValues.${formKeyPrefix}.certType`);
  const certNo = useStore(`formValues.${formKeyPrefix}.certNo`);
  useEffect(() => {
    if (certType === 'I' && isCard(certNo)) {
      const birthday = getBirthday(certNo);
      const sex = getSex(certNo);
      setFormValue({
        [`${formKeyPrefix}.birthday`]: birthday,
        [`${formKeyPrefix}.gender`]: sex
      });
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [certNo, certType]);
  return [disabled, setDisabled];
};

function SexType(label) {
  switch (label) {
    case '男':
      return 'sex_nan';

    case '女':
      return 'sex_nv';

    default:
      return '';
  }
}

export default function RowSex(props) {
  const {
    attrs,
    formKey
  } = props;
  const {
    dataSource
  } = attrs;
  const [disabled] = useDisable(formKey);
  const value = useStore(`formValues.${formKey}`);

  const renderList = () => {
    const sexArr = dataSource.filter(item => item.isDefault !== false);
    return sexArr.map(item => {
      return /*#__PURE__*/React.createElement(Radio, {
        key: item.value,
        value: item.value
      }, /*#__PURE__*/React.createElement(CustomIcon, {
        active: value === item.value,
        type: SexType(item.label)
      }), /*#__PURE__*/React.createElement("span", {
        style: {
          display: 'inline-block',
          verticalAlign: 'text-bottom'
        }
      }, item.label, " "));
    });
  };

  return /*#__PURE__*/React.createElement(RowRadioList, _extends({}, props, {
    className: "c-row-sex",
    renderList: renderList,
    disabled: disabled
  }));
}